import React, { FC } from 'react';
import ProfileAvatar from 'components/profileAvatar/ProfileAvatar';
import { CallJoinRequest } from 'store/services/firebase-broadcast';
import Styles from 'components/Jitsi/CallJoinRequestAlerts.module.scss';

interface CallJoinRequestAlertsProps {
  requests: CallJoinRequest[];
  onAccept: (userPk: number | string) => void;
  onReject: (userPk: number | string) => void;
}

const CallJoinRequestAlerts: FC<CallJoinRequestAlertsProps> = ({
  requests,
  onAccept,
  onReject,
}) => {
  const pending = requests.filter((r) => r.status === 'pending');
  if (pending.length === 0) return null;

  return (
    <div className={Styles.stack} role="region" aria-label="Join requests">
      {pending.map((req) => {
        const pk = req.user.pk;
        const displayName = req.user.name || 'Someone';
        return (
          <div className={Styles.alert} key={String(pk)}>
            <div className={Styles.avatarCol}>
              <ProfileAvatar
                profile={req.user.profile}
                alt={displayName}
                className={Styles.avatar}
              />
            </div>
            <div className={Styles.textCol}>
              <p className={Styles.message}>
                <span className={Styles.joinerName}>{displayName}</span>
                {' wants to join your room'}
              </p>
              <div className={Styles.actions}>
                <button
                  type="button"
                  className={Styles.actionBtn}
                  onClick={() => onAccept(pk)}
                >
                  ACCEPT
                </button>
                <span className={Styles.divider} aria-hidden="true" />
                <button
                  type="button"
                  className={Styles.actionBtn}
                  onClick={() => onReject(pk)}
                >
                  REJECT
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CallJoinRequestAlerts;
